import { Box, styled } from '@mui/system';
import { shadow } from "../../themes/mixins";


const ShadowBox = styled(Box)(() => ({ ...shadow }));


export default ShadowBox;